import styled, { css } from 'styled-components';
import { BasicSelectField, InputField } from 'lib/iterable-hook-form/FormField';
import { ErrorText as ErrorMessage } from 'ui/formField';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { SelectOptionsContainer } from 'ui/selects';

const INPUT_WIDTH = 300;

const inputStyles = css`
  width: ${pxToRem(INPUT_WIDTH)};
`;

export const RowWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
`;

export const ErrorText = styled(ErrorMessage)`
  margin-left: 0;
`;

export const RecurrenceFrequencyInputField = styled(InputField)`
  ${inputStyles}
  input {
    width: 100%;
  }
`;

export const RecurrenceSelect = styled(BasicSelectField)`
  ${inputStyles}
`;

export const RecurrenceSelectOptionsContainer = styled(SelectOptionsContainer)`
  ${inputStyles}
`;
